import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const paymentsAdapter = createEntityAdapter({
  selectId: (invite) => invite._id,
});

const initialState = {
  ui: {
    loading: false,
    loadingOrderHistory: false,
  },
  orders: {},
  payments: paymentsAdapter.getInitialState(),
};

export const ordersReducer = createSlice({
  name: 'order_history',
  initialState,
  reducers: {
    get_orders_success: (state, { payload }) => {
      state.ui.loadingOrderHistory = false;
      state.orders = payload;
    },
    get_orders_error: (state) => {
      state.ui.loadingOrderHistory = false;
    },
    get_orders: (state) => {
      state.ui.loadingOrderHistory = true;
    },
    get_payments_success: (state, { payload }) => {
      state.ui.loading = false;
      paymentsAdapter.setAll(state.payments, payload);
    },
    get_payments_error: (state) => {
      state.ui.loading = false;
    },
    get_payments: (state) => {
      state.ui.loading = true;
    },
    get_recent_payments_success: (state, { payload }) => {
      state.ui.loading = false;
      paymentsAdapter.setAll(state.payments, payload);
    },
    get_recent_payments_error: (state) => {
      state.ui.loading = false;
    },
    get_recent_payments: (state) => {
      state.ui.loading = true;
    },
  },
});

// Action creators are generated for each case reducer function

export const {
  get_orders_success,
  get_orders_error,
  get_orders,
  get_payments_success,
  get_payments_error,
  get_payments,
  get_recent_payments_success,
  get_recent_payments_error,
  get_recent_payments,
} = ordersReducer.actions;

export const paymentsSelectors = paymentsAdapter.getSelectors();

export default ordersReducer.reducer;
